(function () {
  document.documentElement.classList.add('b-anim');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- count-up for stat numbers ---- */
  function countUp(el) {
    if (el.dataset.bCounted) return;
    el.dataset.bCounted = '1';
    var target = el.querySelector('[data-b-num]') || el;
    var raw = target.textContent;
    var m = raw.match(/^([^0-9]*)([\d,]+(?:\.\d+)?)(.*)$/);
    if (!m || reduceMotion) return;
    var prefix = m[1], suffix = m[3];
    var end = parseFloat(m[2].replace(/,/g, ''));
    if (!isFinite(end)) return;
    var decimals = (m[2].split('.')[1] || '').length;
    var useCommas = m[2].indexOf(',') !== -1;
    var dur = 1300, start = null;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (useCommas) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return s;
    }
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      target.textContent = prefix + fmt(end * eased) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else target.textContent = prefix + m[2] + suffix;
    }
    requestAnimationFrame(tick);
  }

  /* ---- staggered scroll reveals ---- */
  function init() {
    var fades = document.querySelectorAll('.b-fade:not(.b-vis)');
    if (!('IntersectionObserver' in window)) {
      fades.forEach(function (el) { el.classList.add('b-vis'); });
      document.querySelectorAll('[data-b-count]').forEach(countUp);
      return;
    }
    var batch = [];
    var flush = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        batch.push(e.target);
      });
      if (batch.length && !flush) {
        flush = requestAnimationFrame(function () {
          batch.forEach(function (el, i) {
            el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
            el.classList.add('b-vis');
            el.addEventListener('transitionend', function h() {
              el.style.transitionDelay = '';
              el.removeEventListener('transitionend', h);
            });
            if (el.hasAttribute('data-b-count')) countUp(el);
            el.querySelectorAll('[data-b-count]').forEach(countUp);
          });
          batch = [];
          flush = null;
        });
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    fades.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
